import { getCircleProps, Radial as RadialComponent } from './Radial';
import { Bar, BarFill } from './styles';
import { StartDirection } from './types';

// eslint-disable-next-line functional/immutable-data -- Assign type
const Radial = Object.assign(RadialComponent, { Bar, BarFill, StartDirection });

export { getCircleProps, Radial, StartDirection };
